import React, { Component } from "react";
import styled from "styled-components";
import { translate } from "react-i18next";
import { TextField } from "material-ui";

import AsapRaisedButton from "../../components/AsapRaisedButton";

class SupportChatInput extends Component {
  state = { newMessage: "" };

  sendMessage() {
    const { newMessage } = this.state;

    this.props.sendMessage(newMessage);
    this.setState({ newMessage: "" });
  }

  render() {
    const { newMessage } = this.state;
    const { t } = this.props;

    return (
      <InputContainer>
        <TextFieldContainer>
          <TextField
            style={{ width: "100%" }}
            floatingLabelFixed
            hintText={t("Напиши нам, как дела")}
            value={newMessage}
            onKeyPress={(ev) => {
              if (ev.key === "Enter") {
                ev.preventDefault();
                this.sendMessage();
              }
            }}
            onChange={(e, v) => this.setState({ newMessage: v })}
          />
        </TextFieldContainer>
        <ButtonContainer>
          <AsapRaisedButton onClick={() => this.sendMessage()} secondary label={t("Отправить")} />
        </ButtonContainer>
      </InputContainer>
    );
  }
}

const InputContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const TextFieldContainer = styled.div`
  flex: 1;
  padding: 10px;
  padding-top: 0px;
`;

const ButtonContainer = styled.div`
  padding: 10px;
`;

export default translate()(SupportChatInput);



// WEBPACK FOOTER //
// ./src/containers/SupportChat/SupportChatInput.js